import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import classnames from 'classnames';
import { FormGroup } from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetRoles } from '../../../api/Roles';

import {
  getCapabilityAttribute,
  userHasCap,
  userIsAdmin,
  userIsManager,
} from '../../../helpers/Auth';
import { getBuiltInRoles } from '../../../helpers/Users';

import ErrorBoundary from '../../ErrorBoundary';
import HelpIcon from '../../HelpIcon';

const AdminUserRoleSelectItem = (props) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div className="role-item">
        <div className="role-item-body">
          <h6 className="role-item-title">
            {data.label}
          </h6>
          {data.description && (
            <span className="role-item-description">
              {data.description}
            </span>
          )}
        </div>
      </div>
    </components.Option>
  );
};

AdminUserRoleSelectItem.propTypes = {
  data: PropTypes.object.isRequired,
};

const AdminUserRoleSelectedItem = (props) => {
  const { data } = props;

  return (
    <components.SingleValue {...props}>
      <div className="role-item">
        <div className="role-item-body">
          <h6 className="role-item-title">
            {data.label}
          </h6>
          {data.description && (
            <span className="role-item-description">
              {data.description}
            </span>
          )}
        </div>
      </div>
    </components.SingleValue>
  );
};

AdminUserRoleSelectedItem.propTypes = {
  data: PropTypes.object.isRequired,
};

class AdminUserEditRoleSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roles: [],
      rolesLoading: true,
    };
  }

  componentDidMount() {
    this.loadRoles();
  }

  getOptions() {
    const {
      intl,
      profile,
    } = this.props;
    const { roles } = this.state;

    const customRoles = [];
    roles.forEach((role) => {
      customRoles.push({
        value: role.id,
        label: role.name,
        description: role.description,
      });
    });
    if (profile.role_id && !customRoles.find(role => role.value === profile.role_id)) {
      customRoles.unshift({
        value: profile.role_id,
        label: profile.role_name,
        description: profile.role_description,
      });
    }

    let allowedRoles = userHasCap('add_users') ? (getCapabilityAttribute('add_users')?.roles || ['user']) : [];
    if (allowedRoles.length === 0 && userHasCap('add_users')) {
      allowedRoles = ['user'];
    }
    if (!profile.role_id && !allowedRoles.includes(profile.role)) {
      allowedRoles.push(profile.role);
    }
    if (userIsAdmin() || userIsManager()) {
      allowedRoles = ['admin', 'manager', 'user'];
    }

    return [
      {
        label: intl.formatMessage({ defaultMessage: 'Default Stockpress roles' }),
        options: getBuiltInRoles(allowedRoles),
      },
      {
        label: intl.formatMessage({ defaultMessage: 'Custom Roles' }),
        options: customRoles,
      },
    ];
  }

  getSelectedRole() {
    const { profile } = this.props;
    const roleValue = profile.role_id || profile.role || null;
    let selectedRole = null;

    this.getOptions().forEach((group) => {
      group.options.forEach((item) => {
        if (item.value === roleValue) {
          selectedRole = item;
        }
      });
    });

    return selectedRole;
  }

  loadRoles() {
    this.setState({ rolesLoading: true });

    APIgetRoles({ all: true }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({ roles: data });
      }
      this.setState({ rolesLoading: false });
    });
  }

  render() {
    const { rolesLoading } = this.state;
    const {
      intl,
      isSelfEdit,
      invalid,
      handleChangeRole,
      isThisUserWorkspaceOwner,
    } = this.props;

    return (
      <ErrorBoundary>
        <div className="user-role">
          <div className="user-role-change">
            <FormGroup className={classnames({ 'is-invalid': invalid })}>
              <Select
                id="selectUserRole"
                inputId="selectUserRoleInput"
                name="user_role"
                className="select-user-role"
                classNamePrefix="select-user-role"
                components={{
                  Option: AdminUserRoleSelectItem,
                }}
                isSearchable={false}
                isDisabled={rolesLoading || isSelfEdit || isThisUserWorkspaceOwner}
                isLoading={rolesLoading}
                placeholder={intl.formatMessage({ defaultMessage: 'Select user Role...' })}
                options={this.getOptions()}
                onChange={handleChangeRole}
                value={this.getSelectedRole()}
              />
              {(isThisUserWorkspaceOwner && !isSelfEdit) && (
                <HelpIcon id="user-role-change-tooltip">
                  {intl.formatMessage({
                    defaultMessage: 'You cannot change the Role of this User as long as it is the Workspace owner',
                  })}
                </HelpIcon>
              )}
            </FormGroup>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

AdminUserEditRoleSelect.propTypes = {
  intl: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  isThisUserWorkspaceOwner: PropTypes.bool,
  isSelfEdit: PropTypes.bool.isRequired,
  invalid: PropTypes.bool,
  handleChangeRole: PropTypes.func.isRequired,
};

AdminUserEditRoleSelect.defaultProps = {
  invalid: false,
  isThisUserWorkspaceOwner: false,
};

export default injectIntl(AdminUserEditRoleSelect);
